import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useId, useMemo } from 'react';
import cns from '../../../../node_modules/classnames/index.js';
import { NOOP } from '../../../../utils/const.js';
import { isUndefined } from '../../../../utils/js.js';
import useForwardRefOrRef from '../../../Hooks/useForwardRefOrRef.js';
import FormFieldFrame from '../FormFieldFrame/FormFieldFrame.js';
import { getFormFieldClassName } from '../classUtilities.js';
import { InputStates } from '../common.js';
import useFieldFlow from '../TextField/useFieldFlow.js';
import { EmphasisLM } from '../../../types.js';

function getTextAreaClassName({ state, disabled = false, readOnly = false, className, }) {
    return cns('v2-textarea-field', getFormFieldClassName(state, disabled, readOnly), className);
}
/**
Componente per l'inserimento non assistito di un dato.

__Il componente è la versione controlled di `Text`. Se possibile utilizzare questo componente__

Vedi [Design System di CGN - Campi di Input](https://zeroheight.com/1b5e94371/p/940c42-campi-di-input/b/003896)

Il componente è "controlled" questo significa che il valore dell'input è gestito esternamente dal componente mediante
la proprietà value e onChange.

Ref: textarea reference.

Constants:

- `TextAreaField.States`: stati ammessi per la proprietà state;
*/
const TextAreaFieldComp = React__default.forwardRef(({ className, disabled, textareaProps, onChange = NOOP, maxCharacters, placeholder, readOnly, state, stateMessage, helperText, componentHeight, flowMode, title, titleIcon, value, icon, size, emphasis = EmphasisLM.MEDIUM, tooltipProps, }, ref) => {
    const id = useId();
    const handleKeyDown = useFieldFlow(flowMode, textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.onKeyDown);
    const [textareaRef, myRef] = useForwardRefOrRef(ref);
    const handleChange = (evt) => {
        onChange(evt.target.value, evt);
    };
    const footer = useMemo(() => {
        if ((maxCharacters && maxCharacters > 0)) {
            return (jsx("div", { className: "v2-textarea-field__footer", children: jsx("span", { className: "v2-textarea-field__character_counter", children: `${value ? value.length : 0}/${maxCharacters}` }) }));
        }
        return null;
    }, [maxCharacters, value]);
    return (jsxs(FormFieldFrame, { className: getTextAreaClassName({
            state, disabled, readOnly, className,
        }), onClick: () => { myRef.current.focus(); }, title: title, titleIcon: titleIcon, state: state, stateMessage: stateMessage, helperText: helperText, componentHeight: componentHeight, icon: icon, readOnly: readOnly, size: size, footer: footer, emphasis: emphasis, tooltipProps: tooltipProps, children: [typeof title === 'string' && jsx("label", { htmlFor: id, children: title }), jsx("textarea", Object.assign({ ref: textareaRef }, textareaProps, { className: "v2-textarea-field__textarea", id: id, value: isUndefined(value) ? '' : value, disabled: disabled || readOnly, placeholder: readOnly ? undefined : placeholder, onChange: handleChange, onKeyDown: handleKeyDown }))] }));
});
TextAreaFieldComp.defaultProps = {
    className: undefined,
    componentHeight: undefined,
    disabled: false,
    onChange: NOOP,
    placeholder: undefined,
    readOnly: false,
    state: undefined,
    stateMessage: undefined,
    helperText: undefined,
    title: undefined,
    icon: undefined,
    textareaProps: undefined,
    value: undefined,
    size: {},
    titleIcon: undefined,
    maxCharacters: undefined,
    emphasis: EmphasisLM.MEDIUM,
    tooltipProps: undefined,
    flowMode: undefined,
};
const TextAreaField = TextAreaFieldComp;
TextAreaField.States = InputStates;

export { TextAreaFieldComp, TextAreaField as default };
